import React, { createContext, useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

const OrgContext = createContext();

export const OrgProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [activeOrg, setActiveOrg] = useState(null);
    const token = sessionStorage.getItem('token');

    const fetchUser = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_SRV}/users/profile`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const userData = response.data.user;
            setUser(userData);

            // Set active organization from sessionStorage or default to the first in organizationIDs
            const storedOrg = sessionStorage.getItem('activeOrg');
            if (storedOrg) {
                const parsedOrg = JSON.parse(storedOrg);
                const matchingOrg = userData.organizationIDs.find(org => org._id === parsedOrg._id);
                setActiveOrg(matchingOrg || userData.organizationIDs[0]);
            } else {
                setActiveOrg(userData.organizationIDs[0]);
            }

        } catch (error) {
            console.error('Error fetching user profile:', error);
            toast.error('Error fetching user profile');
        }
    };

    // Refresh user data to keep context updated
    const refreshUser = async () => {
        await fetchUser();
    };

    // Set active organization in sessionStorage on change
    useEffect(() => {
        if (activeOrg) {
            sessionStorage.setItem('activeOrg', JSON.stringify(activeOrg));
        }
    }, [activeOrg]);

    useEffect(() => {
        fetchUser();
    }, []);

    const contextValue = useMemo(() => ({
        user,
        activeOrg,
        setActiveOrg,
        availableOrgs: user?.organizationIDs || [], // Derived from user data directly
        refreshUser // Expose refreshUser to be used externally
    }), [user, activeOrg]);

    return (
        <OrgContext.Provider value={contextValue}>
            {children}
        </OrgContext.Provider>
    );
};

export default OrgContext;
